module.exports = __webpack_public_path__ + "static/media/right-chevron-grey.081661f3.svg";